import {DataServiceBase} from "../../DataServiceBase";

export class ConditionsService extends DataServiceBase {
    constructor() {
        super('/SmartAccount/Vendors/Conditions');
    }
}